import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";

function GetFakeSystem() {
  const { apiBaseUrl } = useAuth();
  const [target, setTarget] = useState("groups");
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/get/fake-system`,
        { target },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      setResponseData(response.data);
      setMessage("اطلاعات Fake System با موفقیت دریافت شد");
    } catch (error) {
      setMessage(error.response?.data?.message || "خطا در دریافت اطلاعات");
      if (error.response) {
      }
    } finally {
      setLoading(false);
    }
  };

  const fakeSystemData = responseData?.data?.data;

  return (
    <div className="space-y-6 p-6">
      <div className="bg-indigo-900/20 border border-indigo-600 rounded-lg p-4 mb-6">
        <h3 className="text-xl font-semibold text-white mb-2 flex items-center gap-2">
          <span>🎭</span> دریافت اطلاعات Fake System
        </h3>
        <p className="text-indigo-300 text-sm">
          مشاهده وضعیت و اطلاعات سیستم Fake
        </p>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Target Selection */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <label className="block text-white font-medium mb-3">
            انتخاب نوع حساب (Target):
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="individuals"
                checked={target === "individuals"}
                onChange={(e) => setTarget(e.target.value)}
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Individuals (حساب‌های فردی)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="groups"
                checked={target === "groups"}
                onChange={(e) => setTarget(e.target.value)}
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Groups (گروه‌ها)</span>
            </label>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full py-4 px-6 bg-indigo-600 hover:bg-indigo-700 disabled:bg-gray-600 text-white font-bold text-lg rounded-lg transition duration-200 flex items-center justify-center gap-3 shadow-lg"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-6 w-6 border-3 border-white border-t-transparent"></div>
              در حال دریافت...
            </>
          ) : (
            <>
              <span>🎭</span>
              دریافت اطلاعات Fake System
            </>
          )}
        </button>
      </form>

      {/* Fake System Data Display */}
      {fakeSystemData && (
        <div className="space-y-6">
          {/* is_fake_system_start_time_set */}
          <div
            className={`rounded-lg p-5 border-2 ${
              fakeSystemData.is_fake_system_start_time_set === "true"
                ? "bg-yellow-900/20 border-yellow-600"
                : "bg-green-900/20 border-green-600"
            }`}
          >
            <div className="flex items-center gap-3">
              <span className="text-4xl">
                {fakeSystemData.is_fake_system_start_time_set === "true"
                  ? "🎭"
                  : "✅"}
              </span>
              <div>
                <p className="text-white text-base font-medium mb-2">
                  is_fake_system_start_time_set
                </p>
                <p
                  className={`font-bold text-3xl ${
                    fakeSystemData.is_fake_system_start_time_set === "true"
                      ? "text-yellow-400"
                      : "text-green-400"
                  }`}
                >
                  {fakeSystemData.is_fake_system_start_time_set}
                </p>
              </div>
            </div>
          </div>

          {/* fake_system_start_time */}
          <div className="bg-gray-800 border border-gray-600 rounded-lg p-5">
            <div className="flex items-center gap-3 mb-3">
              <span className="text-3xl">🕐</span>
              <h4 className="text-white font-bold text-lg">
                Fake System Start Time
              </h4>
            </div>
            <div className="bg-gray-700/50 rounded p-4">
              <p className="text-white text-base font-medium mb-3">
                fake_system_start_time
              </p>
              <p className="text-white font-bold text-2xl">
                {fakeSystemData.fake_system_start_time}
              </p>
            </div>
          </div>

          {/* current_broker_time */}
          <div className="bg-gray-800 border border-gray-600 rounded-lg p-5">
            <div className="flex items-center gap-3 mb-3">
              <span className="text-3xl">⏰</span>
              <h4 className="text-white font-bold text-lg">
                Current Broker Time
              </h4>
            </div>
            <div className="bg-gradient-to-br from-blue-900/30 to-blue-800/20 rounded p-4 border border-blue-700/50">
              <p className="text-white text-base font-medium mb-3">
                current_broker_time
              </p>
              <p className="text-blue-400 font-bold text-2xl">
                {fakeSystemData.current_broker_time}
              </p>
            </div>
          </div>

          {/* Raw JSON (Optional - for debugging) */}
          <details className="bg-gray-800 border border-gray-600 rounded-lg p-4">
            <summary className="text-white font-medium cursor-pointer hover:text-indigo-400">
              نمایش JSON کامل (برای debugging)
            </summary>
            <pre className="bg-gray-900 p-4 rounded-lg text-gray-300 text-xs overflow-x-auto max-h-96 overflow-y-auto mt-3">
              {JSON.stringify(responseData, null, 2)}
            </pre>
          </details>
        </div>
      )}
    </div>
  );
}

export default GetFakeSystem;
